import { render, staticRenderFns } from "./UserDefinedGroupItemClassList.vue?vue&type=template&id=4cff8f2a"
import script from "./UserDefinedGroupItemClassList.vue?vue&type=script&lang=js"
export * from "./UserDefinedGroupItemClassList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports